import Home from './components/Home'
import './css/main_calculadora.css';

const App = () => {
  return (
    <div id='main'>
      <Home />
      </div>
  );
};

export default App;
